import { getAxiosInstance } from '../client';
/** Mutation API functions for users domain */
export const usersMutations = {
    /** PATCH /users/:id */
    update: (userId, dto) => getAxiosInstance()
        .patch(`/users/${userId}`, dto)
        .then((r) => r.data),
    /** PATCH /users/:id (partial - for single field updates like therapistId, notes, isArchived) */
    patch: (userId, data) => getAxiosInstance()
        .patch(`/users/${userId}`, data)
        .then((r) => r.data),
    /** PATCH /users/:id/allowed-office-locations */
    updateAllowedOfficeLocations: (userId, officeLocationIds) => getAxiosInstance()
        .patch(`/users/${userId}/allowed-office-locations`, officeLocationIds)
        .then((r) => r.data),
    /** POST /users/:id/resent-invite-mail */
    resentInviteMail: (userId) => getAxiosInstance()
        .post(`/users/${userId}/resent-invite-mail`)
        .then((r) => r.data),
    /**
     * POST /users/:id/invite (unified invite: PRACTICE_MANAGED → INVITED, or resend),
     * for any role. A patient is invited at the contact address; a staff member
     * without a login at `email`, since staff have no contact address (#1830).
     */
    invitePatient: (userId, email) => getAxiosInstance()
        .post(`/users/${userId}/invite`, email ? { email } : undefined)
        .then((r) => r.data),
    /** POST /users/:id/unlink-account („Einladung zurückziehen“ / „Zugang trennen“) */
    unlinkAccount: (userId) => getAxiosInstance()
        .post(`/users/${userId}/unlink-account`)
        .then((r) => r.data),
    /** PATCH /users/:userId/basic-anamnesis */
    updateBasicAnamnesis: (userId, dto) => getAxiosInstance()
        .patch(`/users/${userId}/basic-anamnesis`, dto)
        .then((r) => r.data),
    /**
     * POST /users/create-by-therapist. `addressHolder` names the Person of this
     * office whose login the address already is (#1826).
     */
    createByTherapist: (dto) => getAxiosInstance()
        .post('/users/create-by-therapist', dto)
        .then((r) => r.data),
    /** PATCH /users/update-role/:id */
    updateRole: (userId, dto) => getAxiosInstance()
        .patch(`/users/update-role/${userId}`, dto)
        .then((r) => r.data),
    /** POST /users/onboard-user-office */
    onboardOfficeUser: (dto) => getAxiosInstance()
        .post('/users/onboard-user-office', dto)
        .then((r) => r.data),
    /** POST /users/onboard-user-patient-by-therapist */
    onboardPatientByTherapist: (dto) => getAxiosInstance()
        .post('/users/onboard-user-patient-by-therapist', dto)
        .then((r) => r.data),
    /** POST /users/update-email */
    updateOwnEmail: (email) => getAxiosInstance()
        .post('/users/update-email', { email })
        .then((r) => r.data),
    /**
     * POST /users/:userId/update-email. For a patient without a login this saves the
     * office's contact address straight away, and `null` clears it (#1849).
     */
    updateUserEmail: (userId, email) => getAxiosInstance()
        .post(`/users/${userId}/update-email`, { email })
        .then((r) => r.data),
    /** PATCH /users/:userId/patient-status */
    updatePatientStatus: (userId, dto) => getAxiosInstance()
        .patch(`/users/${userId}/patient-status`, dto)
        .then((r) => r.data),
    /** DELETE /users/:id */
    delete: (userId) => getAxiosInstance()
        .delete(`/users/${userId}`)
        .then((r) => r.data),
    /** DELETE /users/:id/newTherapist/:newTherapistId */
    deleteWithNewTherapist: (userId, newTherapistId) => getAxiosInstance()
        .delete(`/users/${userId}/newTherapist/${newTherapistId}`)
        .then((r) => r.data),
    /** POST /users/set-latest-version */
    setLatestVersion: (version) => getAxiosInstance()
        .post('/users/set-latest-version', { version })
        .then((r) => r.data),
    /** PATCH /users/:userId/settings */
    updateSettings: (userId, dto) => getAxiosInstance()
        .patch(`/users/${userId}/settings`, dto)
        .then((r) => r.data),
    /** POST /users/agree-to-newsletter */
    agreeToNewsletter: () => getAxiosInstance()
        .post('/users/agree-to-newsletter')
        .then((r) => r.data),
    /** POST /users/disagree-to-newsletter */
    disagreeToNewsletter: () => getAxiosInstance()
        .post('/users/disagree-to-newsletter')
        .then((r) => r.data),
    /** POST /users/reset-password */
    resetPassword: () => getAxiosInstance()
        .post('/users/reset-password')
        .then((r) => r.data),
    /** PATCH /users/batch-update-patients */
    batchUpdatePatients: (dto) => getAxiosInstance()
        .patch('/users/batch-update-patients', dto)
        .then((r) => r.data),
};
//# sourceMappingURL=users.mutations.js.map